module.exports = __webpack_public_path__ + "img/2.b2d2a8c6.webp";